import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
  Grid,
  Card,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Stack,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Paper,
  ListItemButton,
  Icon,
  CardContent,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import StarIcon from "@mui/icons-material/Star";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import img1 from "./../../assets/premio_1.png";
import img2 from "./../../assets/premio_2.webp";
import img3 from "./../../assets/premio_3.webp";
import img4 from "./../../assets/premio_4.webp";
import img5 from "./../../assets/premio_6.webp";

const premios = [
  { imagem: img1, descricao: 'SmartTV 43"' },
  { imagem: img2, descricao: "Sanduicheira Elétrica" },
  { imagem: img3, descricao: "Air Fryer" },
  { imagem: img4, descricao: "Liquidificador" },
  { imagem: img5, descricao: "Caixa de Som" },
];

// 1. Tema unificado JS Fideliza
const theme = createTheme({
  palette: {
    primary: { main: "#ff6a00" }, // Laranja original ajustado
    secondary: { main: "#002f87" }, // Azul contraste
    background: { default: "#f8f9fa", paper: "#ffffff" },
  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
    h2: { fontWeight: 900, letterSpacing: "-1px" },
    h4: { fontWeight: 800 },
  },
  shape: { borderRadius: 16 },
});

const LandingPage = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* Container Principal Sem Trava de Altura */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {/* --- HEADER --- */}
        <AppBar
          position="sticky"
          color="inherit"
          elevation={0}
          sx={{ borderBottom: "1px solid #eee" }}
        >
          <Container maxWidth="lg">
            <Toolbar
              sx={{ justifyContent: "space-between", px: "0 !important" }}
            >
              <Box
                component="img"
                src="logo-fideliza.png"
                sx={{ height: 60 }}
              />

              <Stack
                direction="row"
                spacing={1}
                sx={{ display: { xs: "none", md: "flex" } }}
              >
                <Button href="#como-funciona" color="inherit">
                  Como funciona
                </Button>
                <Button href="#beneficios" color="inherit">
                  Vantagens
                </Button>
                <Button
                  href="https://cliente.jsfideliza.com.br"
                  color="inherit"
                >
                  Área do Cliente
                </Button>
                <Button
                  onClick={() => navigate("/customer-register")}
                  variant="contained"
                  color="primary"
                  sx={{ ml: 2, fontWeight: 700, color: "#fff" }}
                >
                  CADASTRO
                </Button>
              </Stack>

              <IconButton
                sx={{ display: { md: "none" } }}
                onClick={() => setMobileOpen(true)}
              >
                <MenuIcon />
              </IconButton>
            </Toolbar>
          </Container>
        </AppBar>

        {/* --- HERO SECTION --- */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #ff6a00 0%, #ff8c2a 100%)",
            pt: { xs: 10, md: 15 },
            pb: { xs: 15, md: 20 },

            clipPath: "ellipse(150% 100% at 50% 0%)", // Curva moderna no fundo
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="center">
              <Grid
                item
                size={{ xs: 12, md: 6 }}
                sx={{ textAlign: { xs: "center", md: "left" } }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "2.5rem", md: "3.8rem" },
                    color: "#fff",

                    mb: 2,
                  }}
                >
                  A JS Construções apresenta o
                  <br />
                  <Box component="span" sx={{ color: "#002f87" }}>
                    Programa Fideliza
                  </Box>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ mb: 4, opacity: 0.8, fontWeight: 400, maxWidth: 500 }}
                >
                  A cada 1 real em{" "}
                  <strong style={{ color: "#002f87" }}>tintas</strong>, você
                  acumula pontos e troca por brindes exclusivos. É simples
                  assim!
                </Typography>
                <Button
                  onClick={() => navigate("./customer-register")}
                  variant="contained"
                  size="large"
                  sx={{
                    bgcolor: "#002f87",
                    fontWeight: 600,
                    color: "#fff",
                    px: 5,
                    py: 2,
                    fontSize: "1.1rem",
                    boxShadow: "0 10px 20px rgba(0,47,135,0.3)",
                  }}
                >
                  COMEÇAR AGORA
                </Button>
              </Grid>
              <Grid
                item
                size={{ xs: 12, md: 6 }}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Box
                  component="img"
                  src="personagem_semfundo2.png"
                  sx={{
                    width: "100%",
                    maxWidth: 450,
                    animation: "float 5s ease-in-out infinite",
                    "@keyframes float": {
                      "0%, 100%": { transform: "translateY(0)" },
                      "50%": { transform: "translateY(-20px)" },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* --- CARDS "COMO FUNCIONA" (ESTILO NEUMÓRFICO) --- */}
        <Container id="como-funciona" sx={{ mt: -8, zIndex: 9 }}>
          <Grid container spacing={3}>
            {[
              {
                icon: <StarIcon />,
                title: "Cadastre-se",
                text: "Crie sua conta gratuitamente",
              },
              {
                icon: <ShoppingBagIcon />,
                title: "Compre Tintas",
                text: "Acumule pontos automaticamente",
              },
              {
                icon: <CardGiftcardIcon />,
                title: "Troque por Brindes",
                text: "Resgate recompensas incríveis",
              },
            ].map((item, index) => (
              <Grid item size={{ xs: 12, md: 4 }} key={index}>
                <Paper
                  elevation={4}
                  sx={{ p: 4, textAlign: "center", borderRadius: 5 }}
                >
                  <Box sx={{ color: "primary.main", mb: 2 }}>
                    {React.cloneElement(item.icon, { fontSize: "large" })}
                  </Box>
                  <Typography variant="h6" fontWeight="800">
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.text}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* --- CARROSSEL DE PRÊMIOS --- */}
        <Box id="beneficios" sx={{ py: 10 }}>
          <Container>
            <Typography variant="h4" textAlign="center" sx={{ mb: 6 }}>
              Prêmios para você
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                overflowX: "auto",
                pb: 4,
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {premios.map((p, i) => (
                <Card
                  key={i}
                  sx={{
                    minWidth: 260,
                    borderRadius: 5,
                    flexShrink: 0,
                    border: "1px solid #eee",
                  }}
                >
                  <Box
                    component="img"
                    src={p.imagem}
                    sx={{ height: 180, width: "100%", objectFit: "contain" }}
                  />
                  <Box sx={{ p: 2, textAlign: "center" }}>
                    <Typography fontWeight="700">{p.descricao}</Typography>
                    {/* <Typography
                      variant="caption"
                      color="primary"
                      fontWeight="bold"
                    >
                      500 PONTOS
                    </Typography> */}
                  </Box>
                </Card>
              ))}
              <Card
                sx={{
                  minWidth: 260,
                  borderRadius: 5,
                  flexShrink: 0,
                  border: "1px solid #eee",
                  justifyItems: "center",
                }}
              >
                <CardContent>
                  <Typography sx={{ marginTop: 12 }} fontWeight="700">
                    E muito mais...
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          </Container>
        </Box>

        {/* --- CTA FINAL --- */}
        <Container sx={{ mb: 10 }}>
          <Paper
            sx={{
              p: 6,
              textAlign: "center",
              borderRadius: 8,
              background: "linear-gradient(90deg, #002f87 0%, #0044cc 100%)",
              color: "white",
            }}
          >
            <Typography variant="h4" sx={{ mb: 2 }}>
              Pronto para ganhar?
            </Typography>
            <Typography sx={{ mb: 4, opacity: 0.8 }}>
              Junte-se a milhares de profissionais e clientes JS Construções.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{ fontWeight: 900, px: 6, color: "#fff" }}
              onClick={() => navigate("./customer-register")}
            >
              QUERO ME CADASTRAR
            </Button>
          </Paper>
        </Container>

        {/* --- FOOTER --- */}
        <Box
          sx={{
            py: 5,
            bgcolor: "#111",
            color: "rgba(255,255,255,0.5)",
            textAlign: "center",
          }}
        >
          <Typography variant="caption">
            © {new Date().getFullYear()} JS Construções - Programa Fideliza |
            CNPJ: 44.868.308/0001-29 <br />
            Desenvolvido com foco na sua fidelidade.
          </Typography>
        </Box>

        {/* Menu Mobile */}
        <Drawer
          anchor="right"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
        >
          <List sx={{ width: 250, pt: 5 }}>
            <ListItemButton component="a" href="#como-funciona">
              <ListItemText primary="Como funciona" />
            </ListItemButton>
            <ListItemButton component="a" href="#beneficios">
              <ListItemText primary="Vantagens" />
            </ListItemButton>
            <ListItemButton
              component="a"
              href="https://cliente.jsfideliza.com.br"
            >
              <ListItemText primary="Área do Cliente" />
            </ListItemButton>
            <ListItem sx={{ mt: 2 }}>
              <Button
                onClick={() => navigate("./customer-register")}
                fullWidth
                variant="contained"
                sx={{ color: "#fff", fontWeight: 600 }}
              >
                Cadastro
              </Button>
            </ListItem>
          </List>
        </Drawer>
      </Box>
    </ThemeProvider>
  );
};

export default LandingPage;
